// Single source for the user hover dropdown and the dashboard side menu.
export const defaultUserMenuItems = [
  { name: "Dashboard", tab: "dashboard" },
  {
    name: "Assets",
    tab: "overview",
    children: [
      { name: "Overview", tab: "overview" },
      { name: "Spot", tab: "spot" },
      { name: "Earn", tab: "earn" },
    ],
  },
  { name: "Orders", tab: "spot orders", children: [{ name: "Spot Orders", tab: "spot orders" }, { name: "P2p Order", tab: "p2p order" }, { name: "Transaction History", tab: "transaction history" }] },
  { name: "Earn Plans", tab: "earn plans" },
  { name: "Rewards", tab: "rewards" },
  { name: "Referral", tab: "ReferralDashboard" },
  { name: "Accounts", tab: "account" },
  { name: "Security", tab: "security" },
];

export const dashboardPath = (tab) => (tab ? `/user/dashboard?tab=${encodeURIComponent(tab)}` : "/user/dashboard");
